/* global ADV */

import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import Icon from '../../CommonComponents/Icon';
import { StyledButton as Button } from '../../CommonComponents/Button';

const TransactionsList = styled.ul`
  margin: 0;
  padding: 10px 30px;
  list-style-type: none;
`;

const TransactionsListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  cursor: pointer;

  & + & {
    border-top: 1px solid rgba(151, 151, 151, 0.15);
  }
`;

const TransactionItemDate = styled.div`
  font-size: 13px;
  letter-spacing: 0.1px;
  color: rgba(74, 74, 74, 0.64);
  width: 25px;
  margin-right: 15px;
`;

const TransactionItemDetails = styled.div`
  min-width: 0;
  flex-grow: 1;
  flex-basis: 0;
`;

const TransactionItemDescription = styled.div`
  font-size: 14px;
  letter-spacing: 0.2px;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TransactionItemCategory = styled.div`
  font-size: 12px;
  letter-spacing: 0.1px;
  color: rgba(74, 74, 74, 0.55);
`;

const TransactionItemAmount = styled.div`
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #444444;
  width: 80px;
  text-align: right;
  margin-left: 15px;
`;

const TransactionItemChevron = styled(Icon).attrs({
  className: 'fa fa-chevron-right',
})`
  font-size: 13px;
  line-height: 16px;
  color: #444444;
  margin-left: 15px;
`;

const ShowMoreItem = styled.li`
  padding: 15px 0;
`;

const ShowMoreButton = styled(Button)`
  width: 100%;
  border-radius: 3em;
`;

const EmptyState = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  color: #6C727F;
  flex-grow: 1;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default ({
  transactions,
  onEditTransactionClick,
  currentPage,
  totalPagesCount,
  fetchNextPage,
}) =>
  (transactions.length > 0 ? (
    <TransactionsList>
      {transactions.map(transaction => (
        <TransactionsListItem
          key={transaction.Id}
          onClick={() => onEditTransactionClick(transaction)}
        >
          <TransactionItemDate>
            {moment.utc(new Date(transaction.Date)).format('MMM D')}
          </TransactionItemDate>

          <TransactionItemDetails>
            <TransactionItemDescription>{transaction.Description}</TransactionItemDescription>
            <TransactionItemCategory>{transaction.Category}</TransactionItemCategory>
          </TransactionItemDetails>

          <TransactionItemAmount>
            {transaction.NegativeBalance && '-'}$
            {ADV.util.formatValue(transaction.Balance, 'interest')}
          </TransactionItemAmount>

          <TransactionItemChevron />
        </TransactionsListItem>
      ))}

      {currentPage < totalPagesCount && (
        <ShowMoreItem>
          <ShowMoreButton appearance="primary" onClick={fetchNextPage}>
            Show More
          </ShowMoreButton>
        </ShowMoreItem>
      )}
    </TransactionsList>
  ) : (
    <EmptyState>
      There are no transactions either during this time frame or in this account.
    </EmptyState>
  ));
